export default __webpack_public_path__ + "static/media/style.module.c2b07850.less";